import { useHistory } from 'quartz-routing/react-router';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import getLang from '../../../utils/getLang';
import { reportErrorToLogFetch } from '../../../utils/errorUtils';
import { useMediaQuery } from '../../../utils/Styling';
import { useAssetStatus, useStartLessonProgress, useStartTrackProgress } from '../userProgressQueries';
import { usePlaylistIdFromSearch } from '../../playlistContent/hooks';
import { getOverviewModalEnrollUrl } from '../../overview/overviewRoutingUtils';
import { Metrics } from '../../../utils/Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
const WideUIButton = props => {
  const {
    isMobile,
    isNotMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    as: "span",
    display: "inline-block",
    inlineSize: isMobile ? '100%' : undefined,
    maxInlineSize: "600px",
    minInlineSize: isNotMobile ? '200px' : undefined,
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      block: true
    }, props))
  });
};
export const EnrollTrackButton = ({
  language,
  id,
  onEnroll,
  to
}) => {
  const {
    push
  } = useHistory();
  const playlistId = usePlaylistIdFromSearch();
  const {
    status
  } = useAssetStatus({
    type: 'TRACK',
    id
  });
  const [startTrackProgress, {
    startTrackProgressLoading
  }] = useStartTrackProgress({
    trackId: id,
    language: (language === null || language === void 0 ? void 0 : language.toLowerCase()) || getLang(),
    playlistId
  });
  const handleEnroll = () => {
    const resolvedLanguage = (language === null || language === void 0 ? void 0 : language.toLowerCase()) || getLang();
    startTrackProgress().then(() => {
      Metrics.counter('track-started').increment();
    }).catch(error => {
      Metrics.counter('track-mutation-call-error', {
        action: 'track-start-error'
      }).increment();
      reportErrorToLogFetch({
        loggingTitle: 'Start Track Error',
        action: 'start-track-error',
        error,
        additionalData: {
          trackId: id,
          language: resolvedLanguage
        }
      });
    });
    push(getOverviewModalEnrollUrl({
      to: to !== null && to !== void 0 ? to : `/tracks/${id}`,
      language,
      playlistId
    }));
    onEnroll();
  };
  return /*#__PURE__*/_jsx(WideUIButton, {
    "data-test-id": "overview-enroll-button",
    disabled: startTrackProgressLoading,
    onClick: handleEnroll,
    use: "primary",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `academyComponents.overviewModal.mainAction.track.${status}`
    })
  });
};
export const EnrollLessonButton = ({
  language,
  id,
  onEnroll,
  use = 'primary',
  to
}) => {
  const {
    push
  } = useHistory();
  const playlistId = usePlaylistIdFromSearch();
  const {
    status
  } = useAssetStatus({
    type: 'LESSON',
    id
  });
  const [startLessonProgress, {
    startLessonProgressLoading
  }] = useStartLessonProgress({
    lessonId: id,
    language: (language === null || language === void 0 ? void 0 : language.toLowerCase()) || getLang(),
    playlistId
  });
  const handleEnroll = () => {
    const resolvedLanguage = (language === null || language === void 0 ? void 0 : language.toLowerCase()) || getLang();
    startLessonProgress().then(() => {
      Metrics.counter('lesson-started').increment();
    }).catch(error => {
      Metrics.counter('lesson-mutation-call-error', {
        action: 'lesson-start-error'
      }).increment();
      reportErrorToLogFetch({
        loggingTitle: 'Start Lesson Error',
        action: 'start-lesson-error',
        error,
        additionalData: {
          lessonId: id,
          language: resolvedLanguage
        }
      });
    });
    push(getOverviewModalEnrollUrl({
      to: to !== null && to !== void 0 ? to : `/lessons/${id}`,
      language,
      playlistId
    }));
    onEnroll();
  };
  return /*#__PURE__*/_jsx(WideUIButton, {
    "data-test-id": "overview-enroll-button",
    disabled: startLessonProgressLoading,
    onClick: handleEnroll,
    use: use,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `academyComponents.overviewModal.mainAction.lesson.${status}`
    })
  });
};